module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 columns text-center"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/logo-med.png"),
      "alt": ""
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-3 columns small-centered"
  }, [_c('button', {
    staticClass: "button primary trans-uppercase",
    attrs: {
      "disabled": !_vm.serviceFbReady
    },
    on: {
      "click": _vm.loginWithFacebook
    }
  }, [_vm._v("Bejelentkezés adminként")])])]), _vm._v(" "), (_vm.loginWithEmailAndPasswordEnabled) ? _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('joi-form', {
    attrs: {
      "data": _vm.data,
      "schema": _vm.validationSchema
    },
    on: {
      "formdataready": _vm.loginWithEmailAndPassword
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group small-4 small-centered columns"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.email),
      expression: "data.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.data.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group small-4 small-centered columns"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.password),
      expression: "data.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "jelszó",
      "name": "password"
    },
    domProps: {
      "value": (_vm.data.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group small-4 small-centered columns text-center"
  }, [_c('button', {
    staticClass: "button primary trans-uppercase",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Bejelentkezés")])])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-4 columns small-centered"
  }, [_c('error-callout', {
    attrs: {
      "error": _vm.error
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-3 small-centered columns mt-1 text-center"
  }, [_c('hr')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 small-centered columns mt-1 mb-1 text-center"
  }, [_c('span', [_vm._v("vagy bejelentkezés felhasználónévvel / jelszóval")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39bda73a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Welcome.vue
// module id = 471
// module chunks = 2